module.exports = __webpack_public_path__ + "static/media/Conditional tense spanish.d8a4ca65.jpg";